import React, { useState } from 'react';
import { ButtonMenu } from "../components/menus/ButtonMenu";

import PlatformLogo from "./PlatformLogo";

function SideBar({ data, topName, topIcon }) {
    const [globalClickedMenuId, setGlobalClickedMenuId] = useState(null);
    /** Top 직하위가 모두 링크면 2뎁스(대시보드 등) — 사이드바 1뎁스를 중메뉴 스타일로 */
    const isFlatMenu =
        Array.isArray(data) && data.length > 0 && data.every((item) => !item.children?.length);

    return (
        <div className="sidebar scroll-hidden ">
            <PlatformLogo variant="menu" className={"w-[10rem] cursor-pointer  mx-auto mt-2 mb-8 "}/>
            {/*<img src={Logo} className="block w-[10rem] mx-auto mt-2 mb-8 " alt="logo"/>*/}
            <ButtonMenu
                data={data}
                menuName={topName}
                topIcon={topIcon}
                setGlobalClickedMenuId={setGlobalClickedMenuId}
                globalClickedMenuId={globalClickedMenuId}
                isFlatMenu={isFlatMenu}
            />
        </div>
    );
}

export default SideBar;